import React from 'react';
export default function Footer() {
  return (
    <footer id="footer">
      <ul className="copyright">
        <li>#linhandjames</li>
      </ul>
    </footer>
  );
}
